/*  djw-browse-index.js — dev-build 246. The tiles are rendered by
    sections/djw-browse-index.liquid from the Browse Equipment menu; this only
    builds and wires the pills.
    All is on by default. Tapping a group shows only that group; tapping it again,
    or All, shows everything. The choice goes in the address (#lighting) with
    replaceState, so it can be linked to and adds no history. */
(function () {
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function build(root) {
    var pillsBox = root.querySelector('.djw-bi__pills');
    var groups = Array.prototype.map.call(root.querySelectorAll('.djw-bi__group'), function (sec) {
      return { key: sec.dataset.group, heading: sec.dataset.heading, sec: sec };
    });
    if (!pillsBox || !groups.length) return;
    var pills = [], current = '';
    function pill(key, text) {
      var p = el('button', 'djw-bi__pill', text); p.type = 'button'; p.dataset.group = key;
      p.addEventListener('click', function () { select(key && key === current ? '' : key); });
      pillsBox.appendChild(p); pills.push(p);
    }
    pill('', root.dataset.all || 'All');
    groups.forEach(function (g) { pill(g.key, g.heading); });
    function select(key, fromLoad) {
      if (key && !groups.some(function (g) { return g.key === key; })) key = '';
      current = key;
      pills.forEach(function (p) { var on = p.dataset.group === key; p.classList.toggle('is-active', on); p.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      groups.forEach(function (g) { g.sec.hidden = !!key && g.key !== key; });
      if (!fromLoad) {
        try { history.replaceState(null, '', location.pathname + location.search + (key ? '#' + key : '')); } catch (e) {}
        var top = pillsBox.getBoundingClientRect().top;
        if (top < 0) window.scrollBy(0, top);
      }
    }
    select(decodeURIComponent((location.hash || '').slice(1)), true);
    pillsBox.hidden = false;
    root.classList.add('is-ready');
  }
  function init() { document.querySelectorAll('.djw-bi:not(.is-ready)').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
